// extracted by mini-css-extract-plugin
export default {"btn":"AnimatedBtn_btn__OcMTG","shape":"AnimatedBtn_shape__Y6NZu","flexContent":"AnimatedBtn_flexContent__7qhaD","logo":"AnimatedBtn_logo__vMAJO","shine":"AnimatedBtn_shine__dhvtR"};